module.exports = __webpack_public_path__ + "img/sbzs@2x.a642f540.png";